import { Subsidy } from './clientSettings'
import { MenuItemModVerb, MenuItemMod } from './menuItemMods'

export type ChosenMenuItemModGroup = {
  id: string
  isRequired: boolean
  isSingleOpt: boolean
  name: string
  verb: MenuItemModVerb
  chosenMods: MenuItemMod[]
}

export type OrderItem = {
  id: string
  menuItemId: string
  quantity: number
  price: string
  chosenModGroups: ChosenMenuItemModGroup[]
}

export type SuborderMenu = {
  chefId: string
  cutoffTime: string
  menuId: string
  menuName: string
  orderItems: OrderItem[]
}

export enum SuborderStatus {
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
}

export type Suborder = {
  id: string
  orderNumber: string
  status: SuborderStatus
  menus: SuborderMenu[]
}

export type GroupOrder = {
  id: string
  dateMenusId: string
  date: string
  subsidySettings: Subsidy | null
  orders: Suborder[]
  number: string
}

export type GroupOrderCustomServiceFeeSettings = {
  serviceFees: GroupOrderCustomServiceFee[]
}

export type GroupOrderCustomServiceFee = {
  serviceFeeType: 'Service' | 'Delivery' | 'Processing'
  feeDescription: string
  valueCalculationType: 'Flat Price' | 'Percent of Subtotal'
  value: number | null
  percentValue: number | null
  isTaxExempt: boolean
  itemTaxCode: string | null
}
